module.exports = __webpack_public_path__ + "static/img/invest-TMT8.cea5930.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-TMT8.jpg
// module id = gs0Z
// module chunks = 0